import React, { Component } from "react";
import { getQuestionnairePage } from "../../../redux/actions/sagaActions";
import { connect } from "react-redux";
import QuestionnairePage from "./QuestionnairePage";

class QuestionnairePageLoader extends Component {
  componentDidMount() {
    let { getQuestionnairePage, page } = this.props;
    getQuestionnairePage(page);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.page !== prevProps.page) {
      let { getQuestionnairePage, page } = this.props;
      getQuestionnairePage(page);
    }
  }

  render() {
    let { pages, page } = this.props;
    console.log('pages[page.id]', pages[page.id]);
    return (
      <React.Fragment>
        {pages[page.id] && <QuestionnairePage page={pages[page.id]} initialValues={pages[page.id]} />}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  pages: state.tests.questionnaire_pages
});

export default connect(
  mapStateToProps,
  { getQuestionnairePage }
)(QuestionnairePageLoader);



// WEBPACK FOOTER //
// ./src/modules/test/components/QuestionnairePageLoader.js